import { DataModel, DataModelBuilder, SerializationContext, SerializedData, isSameData } from '../dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { LocalizedString } from './localized-string.js';
import { Seat } from './seating/seat.js';
import { SeatNameFactory } from '../../factories/seat-name-factory.js';

export class SeatingOptions extends DataModel {
  static readonly TYPE_ID: string = '3a578fa286d445bdb89fb80b3fae54b6';

  private constructor(
    public readonly descriptions: LocalizedString,
    public readonly seatId: number,
  ) {
    super();
  }

  get $typeId(): string {
    return SeatingOptions.TYPE_ID;
  }

  static create(args: {
    descriptions: LocalizedString,
    seatId: number,
  }): SeatingOptions {
    return new SeatingOptions(args.descriptions, args.seatId);
  }

  static fromSeat(seat: Seat): SeatingOptions {
    return new SeatingOptions(
        SeatNameFactory.generateLocalizedStringForSeat(seat),
        seat.uniqueId,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): SeatingOptions {
    return new SeatingOptions(
        context.fromData<LocalizedString>(MapUtils.get<SerializedData>(map, 'descriptions')),
        MapUtils.get<number>(map, 'seatId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'descriptions': context.toData(this.descriptions),
      'seatId': this.seatId,
    };
  }

  clone(): this {
    return new SeatingOptions(
        this.descriptions.clone(),
        this.seatId,
    ) as this;
  }

  isSame(other: SeatingOptions): boolean {
    if(this === other) {
      return true;
    }

    return this.seatId == other.seatId &&
      isSameData(this.descriptions, other.descriptions);
  }

  copyWithNames(names: LocalizedString): this {
    return new SeatingOptions(
        names.clone(),
        this.seatId,
    ) as this;
  }
}

export class SeatingOptionsBuilder extends DataModelBuilder<SeatingOptions> {
  build(context: SerializationContext, map: SerializedData): SeatingOptions {
    return SeatingOptions.fromMap(context, map);
  }
}
